import { render, staticRenderFns } from "./SSOLink.vue?vue&type=template&id=3f757bbe&scoped=true&"
import script from "./SSOLink.vue?vue&type=script&lang=js&"
export * from "./SSOLink.vue?vue&type=script&lang=js&"
import style0 from "./SSOLink.vue?vue&type=style&index=0&id=3f757bbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f757bbe",
  null
  
)

export default component.exports